import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';
import {FlattenedNodesObserver} from '@polymer/polymer/lib/utils/flattened-nodes-observer.js';
import {afterNextRender} from '@polymer/polymer/lib/utils/render-status.js';
import {Debouncer} from '@polymer/polymer/lib/utils/debounce.js';
import {timeOut} from '@polymer/polymer/lib/utils/async.js';
import {ResizeObserverBehavior} from '../behaviors/resize-observer-behavior.js';

/**
 * @polymer
 * @mixinFunction
 **/
export const FieldGridBehavior = dedupingMixin((superClass) => class extends ResizeObserverBehavior(superClass) {
  static get properties() {
    return {
      columnCount: {type: Number, observer: 'columnCountChanged'},
      fieldDimensions: {
        type: Object, value: () => {
          return {width: (document.documentElement.clientWidth <= 700 ? 170 : 220), height: 40}
        }
      },
      rowCount: {type: Number, observer: 'rowCountChanged'},
      totalFields: Number
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('panel-controller-visibility', this.handlePanelControllerVisibility);

    this._observer = new FlattenedNodesObserver(this, () => {
      this.recalculateRowsAndColumns();
    });
    this.recalculateRowsAndColumns();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('panel-controller-visibility', this.handlePanelControllerVisibility);

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    this.fieldDimensions = null;
  }

  columnCountChanged(newValue) {
    this.updateStyles({'--field-container-column-count': parseInt(newValue || 1, 10).toString()});
  }

  rowCountChanged(newValue) {
    this.updateStyles({'--field-container-row-count': parseInt(newValue || 1, 10).toString()});
  }

  handleElementResized() {
    this._handleElementResizedJob = Debouncer.debounce(this._handleElementResizedJob, timeOut.after(10), () => {
      this.recalculateRowsAndColumns();
    });
  }

  handlePanelControllerVisibility() {
    this._handlePanelControllerVisibilityJob = Debouncer.debounce(this._handlePanelControllerVisibilityJob, timeOut.after(10), () => this.recalculateRowsAndColumns());
  }

  recalculateRowsAndColumns() {
    afterNextRender(this, () => {
      if (!this.isConnected) return;

      let fields = FlattenedNodesObserver.getFlattenedNodes(this),
        visibleFields = fields.filter(field => !field.hidden);

      this.totalFields = visibleFields.length;
      if (!this.totalFields || !this.fieldDimensions) {
        return;
      }

      let maxColumns = Math.max(Math.floor(this.clientWidth / this.fieldDimensions.width), 1),
        fieldsPerColumn = Math.ceil(this.totalFields / maxColumns),
        columns = Math.ceil(this.totalFields / fieldsPerColumn);

      this.columnCount = (!isNaN(this.columns) && this.columns < columns ? this.columns : columns);
      this.rowCount = Math.ceil(this.totalFields / this.columnCount);
    });
  }
});